import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IDepartmentListResponse,
} from "models/stressCheck/departmentList";
import { httpStatus } from "configs/httpStatus";
import { getDepartmentList } from "services/stressCheck";
import { handleSuccesAction, handleErrorAction } from "./departmentListActions";

function* getDepartmentListSaga() {
  try {
    const response: IDepartmentListResponse = yield call(getDepartmentList);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetDepartmentListWatcher() {
  yield takeLatest(
    ActionType.STRESS_DEPARTMENT_LIST as any,
    getDepartmentListSaga
  );
}

export default [fork(onGetDepartmentListWatcher)];
